// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"j6-z","colorTextValue":"k6-z","swatches":"l6-z","collapseLink":"m6-z","isCollapsed":"n6-z","dropdown":"o6-z","disabled":"p6-z"};